/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { DevNumberFilter } from './DevNumberFilter';
import {
    DevNumberFilterFromJSON,
    DevNumberFilterFromJSONTyped,
    DevNumberFilterToJSON,
    DevNumberFilterToJSONTyped,
} from './DevNumberFilter';
import type { DevDateTimeRange } from './DevDateTimeRange';
import {
    DevDateTimeRangeFromJSON,
    DevDateTimeRangeFromJSONTyped,
    DevDateTimeRangeToJSON,
    DevDateTimeRangeToJSONTyped,
} from './DevDateTimeRange';
import type { DevDateRange } from './DevDateRange';
import {
    DevDateRangeFromJSON,
    DevDateRangeFromJSONTyped,
    DevDateRangeToJSON,
    DevDateRangeToJSONTyped,
} from './DevDateRange';

/**
 * 
 * @export
 * @interface DevPriceRowFilter
 */
export interface DevPriceRowFilter {
    /**
     * 
     * @type {boolean}
     * @memberof DevPriceRowFilter
     */
    isProcessed?: boolean | null;
    /**
     * 
     * @type {DevNumberFilter}
     * @memberof DevPriceRowFilter
     */
    id?: DevNumberFilter;
    /**
     * 
     * @type {DevNumberFilter}
     * @memberof DevPriceRowFilter
     */
    year?: DevNumberFilter;
    /**
     * 
     * @type {DevNumberFilter}
     * @memberof DevPriceRowFilter
     */
    priceUnitId?: DevNumberFilter;
    /**
     * 
     * @type {DevNumberFilter}
     * @memberof DevPriceRowFilter
     */
    productId?: DevNumberFilter;
    /**
     * 
     * @type {DevNumberFilter}
     * @memberof DevPriceRowFilter
     */
    lp?: DevNumberFilter;
    /**
     * 
     * @type {DevNumberFilter}
     * @memberof DevPriceRowFilter
     */
    rrp?: DevNumberFilter;
    /**
     * 
     * @type {Array<DevDateRange>}
     * @memberof DevPriceRowFilter
     */
    validFrom?: Array<DevDateRange> | null;
    /**
     * 
     * @type {Array<DevDateRange>}
     * @memberof DevPriceRowFilter
     */
    validTo?: Array<DevDateRange> | null;
    /**
     * 
     * @type {Array<DevDateTimeRange>}
     * @memberof DevPriceRowFilter
     */
    updatedAt?: Array<DevDateTimeRange> | null;
}

/**
 * Check if a given object implements the DevPriceRowFilter interface.
 */
export function instanceOfDevPriceRowFilter(value: object): value is DevPriceRowFilter {
    return true;
}

export function DevPriceRowFilterFromJSON(json: any): DevPriceRowFilter {
    return DevPriceRowFilterFromJSONTyped(json, false);
}

export function DevPriceRowFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevPriceRowFilter {
    if (json == null) {
        return json;
    }
    return {
        
        'isProcessed': json['isProcessed'] == null ? undefined : json['isProcessed'],
        'id': json['id'] == null ? undefined : DevNumberFilterFromJSON(json['id']),
        'year': json['year'] == null ? undefined : DevNumberFilterFromJSON(json['year']),
        'priceUnitId': json['priceUnitId'] == null ? undefined : DevNumberFilterFromJSON(json['priceUnitId']),
        'productId': json['productId'] == null ? undefined : DevNumberFilterFromJSON(json['productId']),
        'lp': json['lp'] == null ? undefined : DevNumberFilterFromJSON(json['lp']),
        'rrp': json['rrp'] == null ? undefined : DevNumberFilterFromJSON(json['rrp']),
        'validFrom': json['validFrom'] == null ? undefined : ((json['validFrom'] as Array<any>).map(DevDateRangeFromJSON)),
        'validTo': json['validTo'] == null ? undefined : ((json['validTo'] as Array<any>).map(DevDateRangeFromJSON)),
        'updatedAt': json['updatedAt'] == null ? undefined : ((json['updatedAt'] as Array<any>).map(DevDateTimeRangeFromJSON)),
    };
}

export function DevPriceRowFilterToJSON(json: any): DevPriceRowFilter {
    return DevPriceRowFilterToJSONTyped(json, false);
}

export function DevPriceRowFilterToJSONTyped(value?: DevPriceRowFilter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isProcessed': value['isProcessed'],
        'id': DevNumberFilterToJSON(value['id']),
        'year': DevNumberFilterToJSON(value['year']),
        'priceUnitId': DevNumberFilterToJSON(value['priceUnitId']),
        'productId': DevNumberFilterToJSON(value['productId']),
        'lp': DevNumberFilterToJSON(value['lp']),
        'rrp': DevNumberFilterToJSON(value['rrp']),
        'validFrom': value['validFrom'] == null ? undefined : ((value['validFrom'] as Array<any>).map(DevDateRangeToJSON)),
        'validTo': value['validTo'] == null ? undefined : ((value['validTo'] as Array<any>).map(DevDateRangeToJSON)),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt'] as Array<any>).map(DevDateTimeRangeToJSON)),
    };
}

